export const customThemes = {
  retro: {
    "color-scheme": "light",
    primary: "#794A3A", // Dark brown from the retro image
    secondary: "#F5C75B", // Yellow from the retro image
    accent: "#68C7C1", // Turquoise from the retro image
    neutral: "#DD534F", // Coral red from the retro image
    "base-100": "#FAF3E0", // Cream background
    "base-200": "#F1E4C3", // Darker cream
    "base-300": "#E7D5A9", // Even darker cream
    "base-content": "#794A3A", // Dark brown for text
    info: "#68C7C1",
    success: "#68C7C1",
    warning: "#F5C75B",
    error: "#DD534F",
  },
  minimal: {
    "color-scheme": "light",
    primary: "#2A2A2A",
    secondary: "#525252",
    accent: "#737373",
    neutral: "#A3A3A3",
    "base-100": "#FFFFFF",
    "base-200": "#F5F5F5",
    "base-300": "#E5E5E5",
    "base-content": "#171717",
    info: "#737373",
    success: "#525252",
    warning: "#737373",
    error: "#525252",
  },
  print: {
    "color-scheme": "light",
    primary: "#00A8E1", // Cyan
    secondary: "#FF0099", // Magenta
    accent: "#FFE600", // Yellow
    neutral: "#000000", // Key (black)
    "base-100": "#FFFFFF",
    "base-200": "#F9FAFB",
    "base-300": "#F3F4F6",
    "base-content": "#111827",
    info: "#00A8E1",
    success: "#00A8E1",
    warning: "#FFE600",
    error: "#FF0099",
  },
  blueprint: {
    "color-scheme": "dark",
    primary: "#60A5FA", // Bright blue
    secondary: "#93C5FD", // Light blue
    accent: "#3B82F6", // Medium blue
    neutral: "#1D4ED8", // Dark blue
    "base-100": "#1E3A8A", // Darkest blue background
    "base-200": "#1E40AF", // Darker blue
    "base-300": "#1D4ED8", // Dark blue
    "base-content": "#EFF6FF", // Very light blue text
    info: "#60A5FA",
    success: "#93C5FD",
    warning: "#3B82F6",
    error: "#1D4ED8",
  },
};

// Map of theme names to their font families
export const themeFonts = {
  // Custom themes with specific fonts
  retro: "'Space Grotesk', sans-serif",
  minimal: "'Space Mono', monospace",
  print: "'Roboto Condensed', sans-serif",
  blueprint: "'Inter', sans-serif",

  // Default DaisyUI themes
  light: "'Inter', system-ui, sans-serif",
  dark: "'Inter', system-ui, sans-serif",
  synthwave: "'Inter', system-ui, sans-serif",
  valentine: "'Inter', system-ui, sans-serif",
  halloween: "'Inter', system-ui, sans-serif",
  forest: "'Inter', system-ui, sans-serif",
  aqua: "'Inter', system-ui, sans-serif",
  lofi: "'Inter', system-ui, sans-serif",
  luxury: "'Inter', system-ui, sans-serif",
  dracula: "'Inter', system-ui, sans-serif",
  autumn: "'Inter', system-ui, sans-serif",
  business: "'Inter', system-ui, sans-serif",
  lemonade: "'Inter', system-ui, sans-serif",
  night: "'Inter', system-ui, sans-serif",
  coffee: "'Inter', system-ui, sans-serif",
  winter: "'Inter', system-ui, sans-serif",
} as const;
